import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import { Delete, PictureAsPdf } from "@mui/icons-material";
import { setPDFData } from "../../../../../components/hooks/printPdf/pdfData";
import { useNavigate } from "react-router-dom";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";

const PurchaseReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowData, setRowData] = useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const[cust, setCust] = useState(null)
  const[purchaseLines , setPurchaseLines] = useState([])
  const [open , setOpen] = useState(false)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1,'months').format(),
    toDate : moment().format()
  })
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const outletId = localStorage.getItem('outlet_id')

  const roleId = localStorage.getItem("role_id")
  const [rowToDelete, setRowToDelete] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

  const convertNumber = (num) => {
    if (num === 0) return 'Zero';

    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };


const onEdit = (e) => {
  console.log(e.row)
  setPurchaseLines(e.row.purchase_lines)
  setRowData(e.row)
  setOpen(true)
}


function handlePDF(e){
console.log(e)
const TotalData = {
  cess_amt : e.cess,
  sub_total : e.sub_total,
  gst: e.gst_Amt,
  totalAmount : e.tot,
  roundOff : e.roff,
}
const tableData = _.map(e.purchase_lines, (val=>({
  pro_name : val.pro_name,
  sale_rate:val.rate,
  qty:val.qty,
  disc1:val.dis_per,
  cgstPerc:val.gst_per,
  cgstAmnt : val.gst_amt,
  totalAmt:val.rate * val.qty,
  hsn: val.hsn,
})))
console.log(data)
console.log(TotalData , "totaldata" , tableData , "tabledata")
axios.post(`/v1/purchase/getall`,{docno : e.billNo})
.then(res=>{
dispatch(setPDFData({
  tableData : tableData,
  TotalData : TotalData,
  companyInfo : res.data,
  totalText : convertNumber(e.tot),
  title:'Purchase Invoice'
  
}))      
const name = `BillNo_${e.billNo}`
navigate(`/invoice/${name}`)  
})
.catch(err=>{
  console.log(err)
  dispatch(
    setSnackbar(true, "error", err.response.data.errors[0].message)
  );
})


// dispatch(setPDFData({
//   tableData : e.purchase_lines,
//   // TotalData : 
// }))
}
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "billNo",
    headerName: "Bill No",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Supplier Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amt",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "cgst",
    headerName: "CGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sgst",
    headerName: "SGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  // {
  //   field: "igst",
  //   headerName: "IGST",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "cess",
  //   headerName: "Cess",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "dis",
  //   headerName: "Dis",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "tot",
    headerName: "Total",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    disableExport: true ,
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return (
  <div className="flex">
          <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon sx={{fontSize: 16}}/>
        </IconButton>
        <IconButton size="small" onClick={()=>handlePDF(params.row)}><PictureAsPdf sx={{fontSize: 16}} /></IconButton>
  </div>
      );
    },
  },
  {
    field: "action",
    headerName: roleId == 2 || roleId == 1 ? "Action": "",
    disableExport: true ,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      // console.log(params.row)
      const { row, index } = params;
      return (
        <div>

          {roleId == 2 || roleId == 1 ? 
          
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '5px' }}>
          <IconButton 
          // onClick={() => setOpenDeleteModal(true)}
          onClick={() => handleDeleteRow(row, index)} 
          aria-label="delete">
              <Delete sx={{ color: "red", fontSize: 18 }} />
          </IconButton>
      </div>
          
          :null}

        </div>

      );
    },
  },
]

const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.docdate).format("DD-MM-YYYY"),
  billNo : val.docno,
  party : val.name,
  amt : parseFloat(val.amount).toFixed(0),
  cess : parseFloat(val.cess_amt).toFixed(0),
  cgst:parseFloat(val.gst_amt / 2).toFixed(0),
  sgst:parseFloat(val.gst_amt / 2).toFixed(0),
  gst_Amt : parseFloat(val.gst_amt).toFixed(0),
  tot:parseFloat(val.amount).toFixed(0),
  purchase_lines:val.purchase_lines,
  roff: val.roff,
  tot_amt: parseFloat(val.amount).toFixed(0),
  documentNo:val.docno,
  documentDate:moment(val.docdate).format("DD-MM-YYYY"),
  // sub_total : parseFloat(val.amount - val.gst_amt - val.cess_amt + val.roff).toFixed(0) ,
  sub_total : parseFloat(val.amount - val.gst_amt  + val.roff).toFixed(0) ,

  gst_per: val.purchase_lines?.[0]?.gst_per || "-", // Fetch GST %


}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
const handleDeleteRow = (row, index) => {
  setRowToDelete(row); // Store row data to be deleted
  setDeleteIndex(index); // Store index
  setOpenDeleteModal(true); // Open the modal
};
const handleConfirmDelete = () => {
  const deleteData = {
    docno: rowToDelete.billNo, 
  };

  axios
    .post(`/v1/purchase/delete`, deleteData)
    .then((res) => {
      // Handle success response
      const updatedData = [...data];
      updatedData.splice(deleteIndex, 1); // Remove the deleted row from the state
      setData(updatedData); // Update state with new data
      setOpenDeleteModal(false); // Close modal after deletion
      dispatch(setSnackbar(true , 'success' , 'Deleted successfully'))
      handlePurchaseReport()
    })
    .catch((err) => {
      console.log(err); // Handle error
    });
};
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/supplier")
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        console.log(err)
        dispatch(setSnackbar(true, "error", err.response.error));
      });
  }
function handlePurchaseReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ?  cust.id : 0
  }
  axios.post('/v1/reports/purchase', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}
  useEffect(() => {
    getSupplierData();
  }, []);

  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handlePurchaseReport()
    }
  },[rowsPerPage, page, dateLimit, cust])
  const tableHeadData = [
    { id:1, label: "S No" },
    { id:2, label: "Product name" },
    // { id:3, label: "Doc No" },
    // { id:4, label: "Doc date" },
    { id:3 , label:"Purchase Rate"},
    { id:4 , label:"Gst Amnt"},
    { id:5 , label:"Gst Per %"},
    { id:6 , label:"Qty"},
    // { id:7 , label:"Rate"},
    {id:7, label: 'Total'}
  ];
  const tableBodyData = _.map(purchaseLines, (val,idx) => ({
    id:idx,
    sNo:idx+1,
    name:val.pro_name,
    docNo:val.docno,
    docDate:moment(val.docdate).format('DD-MM-YYYY'),
    Mrp:val.rate,
    gstAmnt:val.gst_amt,
    gstPer:val.gst_per,
    Qty:val.qty,
    // Rate:val.rate,
    totalAmount : parseFloat( val.qty * val.rate ).toFixed(0)
  }))
  return (
    <Fragment>
      <Helmet><title>Purchase Reports</title></Helmet>
      <Typography variant="h6">Purchase Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{ id: 0, name: 'All' }, ...supplier]}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.name}
            renderInput={(params) => <TextField {...params} label="Select Supplier"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>

      <Backdrop open={open} sx={{zIndex:9999}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
      <Backdrop open={openDeleteModal} sx={{zIndex:1350}} onClose={() => setOpenDeleteModal(false)}>
  <DeletePage onCancel={setOpenDeleteModal} onSubmit={handleConfirmDelete}/>
</Backdrop>
    </Fragment>
  );
};

export default PurchaseReport;
